import { Component, OnInit } from '@angular/core';
import { forgotPassword } from '../models/forgetPassword';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ViewChild } from '@angular/core';

@Component({
  selector: 'app-forgetpassword',
  templateUrl: './forgetpassword.component.html',
  styleUrls: ['./forgetpassword.component.css']
})
export class ForgetpasswordComponent implements OnInit {
  @ViewChild("mobileAuthetication") form: any;
  @ViewChild("forgotPassword") formUpdate: any;

  forgetAddObj: forgotPassword;
  confirmPassword: any;
  showMobile: boolean = false
  constructor(private cs: CucurachaAdminService, private toastr: ToastrManager) {
    this.forgetAddObj = new forgotPassword();
  }
  show: boolean = false
  showReset: boolean = false
  showSignIn: boolean = false
  userName: any = "e";
  mobilenumber:any;
  email:any
  otp:any;
  sendOtp(contact:any) {
    this.show = true
if(this.userName=="e"){
    this.cs.sendMail(contact).subscribe((data) => {

    })
    this.toastr.infoToastr("If this Email Exists in our records an OTP should be received soon");
  }
  else{
    this.cs.sendOtpSms(contact).subscribe((data) => {
      if(data.body){
        this.toastr.infoToastr(data.message)
      }
      else{
        this.toastr.errorToastr(data.message)
      }

    })
  }
  }
  reSendOtp(contact:any){
    alert(contact)
    if(this.userName=="e"){
    this.toastr.warningToastr("If this Email Exists in our records an OTP should be received soon");
    this.cs.sendMail(contact).subscribe((data) => {
      console.log(data)

    })
    }
    else{
      this.cs.sendOtpSms(contact).subscribe((data) => {
        if(data.body){
          this.toastr.infoToastr(data.message)
        }
        else{
          this.toastr.errorToastr(data.message)
        }
  
      })

    }
  }
  resetForgotForm() {
    if(this.userName=="e"){
      this.cs.OtpVerification(this.otp,this.email).subscribe((data) => {
       if(data.result){
         this.showReset = true

       }
       else {
        this.toastr.errorToastr(data.message);

       }
      })
    }
    else{
      this.cs.otpVerificationWithMobileNumber(this.otp,this.mobilenumber).subscribe((data) => {
       if(data.result){
         this.showReset = true

       }
       else {
        this.toastr.errorToastr(data.message);

       }
      })

    }
  }
  resetPasswordThroughEmail() {

    // if (this.userName = "m") {
    //   console.log(this.mobilenumber)
    //   this.forgetAddObj.userName = this.mobilenumber;
    //   console.log(this.forgetAddObj.userName)

    // }
    // else if (this.userName = "e")
    // {
    //   this.forgetAddObj.userName = this.email;
    // }
    if (this.forgetAddObj.resetPassword == this.confirmPassword) {
           this.forgetAddObj.userName = this.email;

        this.cs.passwordReset(this.forgetAddObj).subscribe((data) => {
          if (data.result) {
            this.toastr.successToastr(data.message);
            this.formUpdate.reset()
            this.showSignIn = true

          }
          else if (data.err) {
            this.toastr.warningToastr(data.message);

          }
          else {
            this.toastr.errorToastr(data.message);

          }
        })
    } else {
      this.toastr.warningToastr("Reset password and Confirm password should be same")
    }
  }
  resetPasswordThroughMobile() {

    // if (this.userName = "m") {
    //   console.log(this.mobilenumber)
    //   this.forgetAddObj.userName = this.mobilenumber;
    //   console.log(this.forgetAddObj.userName)

    // }
    // else if (this.userName = "e")
    // {
    //   this.forgetAddObj.userName = this.email;
    // }
    if (this.forgetAddObj.resetPassword == this.confirmPassword) {
      this.forgetAddObj.userName = this.mobilenumber;

        this.cs.passwordReset(this.forgetAddObj).subscribe((data) => {
          if (data.result) {
            this.toastr.successToastr(data.message);
            this.formUpdate.reset()
            this.showSignIn = true

          }
          else if (data.err) {
            this.toastr.warningToastr(data.message);

          }
          else {
            this.toastr.errorToastr(data.message);

          }
        })
    } else {
      this.toastr.warningToastr("You must enter reset password and confirm password should be same")
    }
  }
  userNameField() {
    if (this.userName == "m") {
      this.showMobile = true
    }
    if (this.userName == "e") {
      this.showMobile = false
    }
  }
  ngOnInit(): void {
  }

}
